import theme from '@adflow/theme';
import { FeatureFlagProvider } from '@adflow/utils';
import { IMarketingCloudUser } from '@ads/iam-library';
import { ApolloProvider } from '@apollo/client';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { Router } from '@remix-run/router';
import { QueryClientProvider } from '@tanstack/react-query';
import { FC, StrictMode } from 'react';
import { RouterProvider } from 'react-router-dom';
import { TRPCClient, trpc, useTRPCReact } from './Templates/utils/apiClient';
import UserProvider from './UserProvider';
import { userToRequestContextAuthorizationHeader } from './UserProvider/models/User';
import client from './apolloClient';
import env from './env';

export const App: FC<{ router: Router; user: IMarketingCloudUser | null }> = ({ router, user }) => {
  if (env.localMode && user) {
    const header = userToRequestContextAuthorizationHeader(user);
    TRPCClient.setRequestContextAuthorizationHeader(header);
  }

  const { trpcClient, queryClient } = useTRPCReact(
    env.localMode && user ? userToRequestContextAuthorizationHeader(user) : undefined,
  );

  if (env.localMode && user) {
    const header = userToRequestContextAuthorizationHeader(user);
    TRPCClient.setRequestContextAuthorizationHeader(header);
  }

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <StrictMode>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <ApolloProvider client={client}>
              <FeatureFlagProvider>
                <UserProvider user={user}>
                  <RouterProvider router={router} fallbackElement={<p>Initial Load...</p>} />
                </UserProvider>
              </FeatureFlagProvider>
            </ApolloProvider>
          </ThemeProvider>
        </StrictMode>
      </QueryClientProvider>
    </trpc.Provider>
  );
};
